import { fetchAndyAgentsReplyMock, fetchAndyAgentsWidgetNextMock } from '@/components/domain/andy-agents/andyAgentsReplyMock.js'

const state = {}

const actions = {
    fetchReply(context, message) {
        // Pendiente de API: sustituir esta llamada por api de src/core/api.js,
        // devolver { text, widgets } y eliminar andyAgentsReplyMock.js.
        return fetchAndyAgentsReplyMock(message)
    },
    fetchWidgetNext(context, payload) {
        // Pendiente de API: sustituir por api de src/core/api.js con offset o nextCursor.
        return fetchAndyAgentsWidgetNextMock(payload)
    },
    submitFeedback(context, payload) {
        const messageId = payload && payload.messageId
        const feedback = payload && payload.feedback
        const isKnownFeedback = feedback === 'useful' || feedback === 'not_useful'

        if (!messageId || !isKnownFeedback) {
            return Promise.resolve({ status: false })
        }

        // TODO: cuando exista el endpoint, enviar { messageId, feedback }
        // con api de src/core/api.js. De momento no hay petición.
        return Promise.resolve({
            status: true,
            messageId: messageId,
            feedback: feedback
        })
    }
}

export default {
    namespaced: true,
    state,
    actions
}
